import { useEffect } from "react";
import "./styles/global-styles.scss";
// import ImageCarousel from "./components/ImageCarousel";
import MailingList from "./components/MailingList";
import Header from "./components/Header";
// import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    function updateAppHeight() {
      const height = window.innerHeight;
      document.documentElement.style.setProperty("--app-height", `${height}px`);
    }

    updateAppHeight();
    window.addEventListener("resize", updateAppHeight);
    window.addEventListener("orientationchange", updateAppHeight);
  }, []);

  // Images live in /public
  // const images = [
  //   "/assets/joe-bradley_01.png",
  //   "/assets/joe-bradley_02.png",
  //   "/assets/joe-bradley_03.png",
  //   "/assets/joe-bradley_04.png",
  // ];

  return (
    <main className="spettacolo__container">
      <Header />
      <div className="spettacolo__logo-wrapper">
        <img src="/assets/SPETTACOLO_logo.png" className="spettacolo__logo" alt="SPETTACOLO"/>
      </div>
      {/* <ImageCarousel images={images} interval={4000} fadeDuration={800} /> */}
      <MailingList />
    </main>
  );
}

export default App;
